(() => {
  const buttonSelector = '[data-sw-cod-buy-now]';

  async function addCurrentProduct(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    const component = button.closest('product-form-component');
    const form = component?.querySelector('form[data-type="add-to-cart-form"]');
    if (!(form instanceof HTMLFormElement)) return;

    const label = button.querySelector('span');
    const original = label?.textContent || 'شراء الآن';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'جاري تجهيز الطلب…';

    try {
      const data = new FormData(form);
      const id = String(data.get('id') || '');
      if (!/^\d+$/.test(id)) throw new Error('اختر المواصفات المطلوبة أولًا.');

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: data,
        credentials: 'same-origin'
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(payload?.description || payload?.message || 'تعذر إضافة المنتج إلى السلة.');

      window.location.assign(new URL(root + 'cart?cod=1', window.location.origin).href);
    } catch (error) {
      const region = component?.querySelector('[data-sw-product-form-error]');
      const message = error instanceof Error ? error.message : 'تعذر تجهيز الطلب.';
      if (region) {
        region.textContent = message;
        region.hidden = false;
      } else {
        alert(message);
      }
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (label) label.textContent = original;
    }
  }

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(buttonSelector);
    if (!button) return;
    event.preventDefault();
    addCurrentProduct(button);
  });
})();